
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/one/[[...slugs]]",
      function () {
        return require("private-next-pages/one/[[...slugs]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/one/[[...slugs]]"])
      });
    }
  